"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreDocumentUploadStepQueryToJSON = exports.PreDocumentUploadStepQueryFromJSONTyped = exports.PreDocumentUploadStepQueryFromJSON = void 0;
const _1 = require("./");
function PreDocumentUploadStepQueryFromJSON(json) {
    return PreDocumentUploadStepQueryFromJSONTyped(json, false);
}
exports.PreDocumentUploadStepQueryFromJSON = PreDocumentUploadStepQueryFromJSON;
function PreDocumentUploadStepQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'linkingDocExpectedCount': json['linkingDocExpectedCount'],
        'uploadedFiles': (json['uploadedFiles'].map(_1.DocumentMetaFromJSON)),
    };
}
exports.PreDocumentUploadStepQueryFromJSONTyped = PreDocumentUploadStepQueryFromJSONTyped;
function PreDocumentUploadStepQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'linkingDocExpectedCount': value.linkingDocExpectedCount,
        'uploadedFiles': (value.uploadedFiles.map(_1.DocumentMetaToJSON)),
    };
}
exports.PreDocumentUploadStepQueryToJSON = PreDocumentUploadStepQueryToJSON;
//# sourceMappingURL=PreDocumentUploadStepQuery.js.map